import React from 'react';
import cn from 'classnames';

import { BaseAccordion, AccordionContent, AccordionItem, AccordionTrigger } from './BaseAccordion';

export type AccordionProps = {
    type: 'single' | 'multiple';
    collapsible?: boolean;
    children: React.ReactNode;
    className?: string;
};

const Accordion: React.FC<AccordionProps> = ({ type, collapsible = true, children, className }) => {
    return (
        <BaseAccordion type={type} collapsible={collapsible} className={cn('w-full', className)}>
            {children}
        </BaseAccordion>
    );
};

Accordion.displayName = 'Accordion';

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
